<div class="dashboard-card list-card">
  <div class="widget-header">
    <h5>
      Software DEMO Requests
    </h5>

		<!-- <div class="btn-group btn-group-sm" role="group" aria-label="Basic radio toggle button group">
			<input type="radio" class="btn-check" name="btnradio" id="btnradio1" [value]="'Pending'" [(ngModel)]="urType" checked>
			<label class="btn btn-outline-secondary" for="btnradio1">Pending Req.</label>

			<input type="radio" class="btn-check" name="btnradio" id="btnradio2" [value]="'Invalid'" [(ngModel)]="urType">
			<label class="btn btn-outline-secondary" for="btnradio2">Invalid Req.</label>

			<input type="radio" class="btn-check" name="btnradio" id="btnradio3" [value]="'Done'" [(ngModel)]="urType">
			<label class="btn btn-outline-secondary" for="btnradio3">Verified Req.</label>
		</div> -->
		<nav class="d-flex gap-2">
			<button class="chip" (click)="urType=''">
				<i class="bi bi-people-fill"></i>
				<span>All Demo Req.</span>
			</button>
			<button class="chip" (click)="urType='Pending'">
				<i class="bi bi-person-check-fill"></i>
				<span>Pending Req.</span>
			</button>
			<button class="chip" (click)="urType='Rejected'">
				<i class="bi bi-person-lines-fill"></i>
				<span>Invalid Req.</span>
			</button>
			<button class="chip" (click)="urType='Converted'">
				<i class="bi bi-person-fill-check"></i>
				<span>Verified Req.</span>
			</button>
		</nav>

		<button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
			+Add New
		</button>
  </div>

	<div class="w-100">
		<table class="table table-striped w-100">
      <thead>
        <tr>
          <th>#</th>
          <th>Req. Date</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Inst. Type</th>
          <th>Pref. Date/Time</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for(data of allData; track $index; let idx = $index;) {
        <tr *ngIf="urType=='' || (urType=='Pending' && (data.status!='Converted' && data.status!='Rejected' && data.status!='Closed')) || data.status==urType">
          <td>{{idx+1}}.</td>
          <td>{{dataService.ymd2dmy(data?.req_date)}}</td>
          <td>{{data.full_name}}</td>
          <td>{{data.mobile_no}}</td>
          <td>{{dataService.getInstituteType(data?.inst_type)}}</td>
          <td>{{dataService.ymd2dmy(data?.pref_date)}} at {{data?.pref_time?.substr(0, 5)}}</td>
          <td><span class="badge py-1" [ngClass]="statusBadge[data.status]">{{data.status}}</span></td>
					<!-- <td>{{data.is_active}}</td> -->
          <td class="d-flex gap-3">
						<span style="cursor: pointer;" (click)="demoData=data;" data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasRight" title="View Details">
							<i class="bi bi-eye text-primary"></i>
						</span>

						<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
							(click)="editClick(data)" title="Modify">
							<i class="bi bi-pencil-square text-success"></i>
						</span>

						<span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
							<i class="bi bi-trash3 text-danger"></i>
						</span>
          </td>
        </tr>
        }
      </tbody>
    </table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available.
		</div>

  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasRightLabel">Demo Request Details</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body">
		<table class="table table-striped-columns">
			<tbody>
				<tr>
					<td>Req. Date:</td>
					<td>{{dataService.ymd2dmy(demoData?.req_date)}}</td>
				</tr>
				<tr>
					<td>Institute Name:</td>
					<td>{{demoData?.inst_name}}</td>
				</tr>
				<tr>
					<td>Institute Type:</td>
					<td>{{dataService.getInstituteType(demoData?.inst_type)}}</td>
				</tr>
				<tr>
					<td>Institute Website:</td>
					<td>{{demoData?.inst_website}}</td>
				</tr>
				<tr>
					<td>Name:</td>
					<td>{{demoData?.full_name}}</td>
				</tr>
				<tr>
					<td>Designation:</td>
					<td>{{dataService.getDesiName(demoData?.designation)}}</td>
				</tr>
				<tr>
					<td>Mobile No.:</td>
					<td>{{demoData?.mobile_no}}</td>
				</tr>
				<tr>
					<td>Email ID:
						<!-- <button class="btn btn-sm btn-warning py-0" data-bs-dismiss="offcanvas" style="float: right;" 
							[disabled]="demoData?.status!='Converted'" (click)="setupTrialSW(demoData)">Send Trial</button> -->
					</td>
					<td>{{demoData?.email_id}}</td>
				</tr>
				<tr>
					<td>Student Counts:</td>
					<td>{{demoData?.student_counts}}</td>
				</tr>
				<tr>
					<td>Source:</td>
					<td>{{dataService.getSourceName(demoData?.source) || demoData?.source}}</td>
				</tr>

				<tr>
					<td>Pref. Date/Time:</td>
					<td>{{dataService.ymd2dmy(demoData?.pref_date)}} {{demoData?.pref_time}}</td>
				</tr>
				<tr>
					<td>Message:</td>
					<td>{{demoData?.message}}</td>
				</tr>
				<tr>
					<td>Status:</td>
					<td>{{demoData?.status || 'Pending'}}</td>
				</tr>
			</tbody>
		</table>

		<div class="w-100 d-flex justify-content-center gap-2 mb-3" data-bs-dismiss="offcanvas">
			<button type="button" class="btn btn-sm btn-success" (click)="statusClick(demoData, 'Converted')" *ngIf="!demoData?.status || demoData?.status != 'Done'">
				<i class="bi bi-calendar-check"></i> Mark Done!
			</button>
			<button type="button" class="btn btn-sm btn-success" (click)="setupNewAccount(demoData)" data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
				<i class="bi bi-gear"></i> Setup New Account
			</button>
			<button type="button" class="btn btn-sm btn-danger" (click)="statusClick(demoData, 'Rejected')" *ngIf="demoData?.status != 'Invalid'">
				<i class="bi bi-eye-slash"></i> Rejected
			</button>
		</div>
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Demo Request Form</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="min-height: 400px;">
				<app-demo-form [action]="btnClick"></app-demo-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal"
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="staticBackdropLabel2" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl kyc-body">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleLabel">KYC Details View: {{selUser?.display_name}}</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
					*ngIf="!dataService.onBoarding"></button>
			</div>
			<div class="modal-body" style="height: 92vh;">
				<app-view-kyc [user]="selUser"></app-view-kyc>
			</div>
		</div>
	</div>
</div>
